import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import Router from "./router/Router";
import store from "./redux/store";
//import registerServiceWorker from './registerServiceWorker';

const App = (
  <Provider store={store}>
    <Router />
  </Provider>
);

console.log("start");

render(App, document.getElementById("root"));

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.jsx